import PropTypes from 'prop-types';
import AdvertisingSlotConfigPropType from './AdvertisingSlotConfigPropType';

export default PropTypes.shape({
  path: PropTypes.string,
  targeting: PropTypes.object,
  usePrebid: PropTypes.bool,
  prebid: PropTypes.shape({
    debug: PropTypes.bool,
    bidderTimeout: PropTypes.number,
    enableSendAllBids: PropTypes.bool,
    bidderSequence: PropTypes.oneOf(['random', 'fixed']),
    publisherDomain: PropTypes.string,
    cookieSyncDelay: PropTypes.number,
    priceGranularity: PropTypes.oneOfType([
      PropTypes.oneOf(['low', 'medium', 'high', 'auto', 'dense']),
      PropTypes.shape({
        buckets: PropTypes.arrayOf(
          PropTypes.shape({
            precision: PropTypes.number,
            max: PropTypes.number.isRequired,
            increment: PropTypes.number.isRequired,
          })
        ).isRequired,
      }),
    ]),
    mediaTypePriceGranularity: PropTypes.shape({
      video: PropTypes.oneOfType([
        PropTypes.oneOf(['low', 'medium', 'high', 'auto', 'dense']),
        PropTypes.shape({
          buckets: PropTypes.arrayOf(
            PropTypes.shape({
              precision: PropTypes.number,
              max: PropTypes.number.isRequired,
              increment: PropTypes.number.isRequired,
            })
          ).isRequired,
        }),
      ]),
      banner: PropTypes.oneOfType([
        PropTypes.oneOf(['low', 'medium', 'high', 'auto', 'dense']),
        PropTypes.shape({
          buckets: PropTypes.arrayOf(
            PropTypes.shape({
              precision: PropTypes.number,
              max: PropTypes.number.isRequired,
              increment: PropTypes.number.isRequired,
            })
          ).isRequired,
        }),
      ]),
      native: PropTypes.oneOfType([
        PropTypes.oneOf(['low', 'medium', 'high', 'auto', 'dense']),
        PropTypes.shape({
          buckets: PropTypes.arrayOf(
            PropTypes.shape({
              precision: PropTypes.number,
              max: PropTypes.number.isRequired,
              increment: PropTypes.number.isRequired,
            })
          ).isRequired,
        }),
      ]),
    }),
    sizeConfig: PropTypes.arrayOf(
      PropTypes.shape({
        mediaQuery: PropTypes.string.isRequired,
        sizesSupported: PropTypes.arrayOf(
          PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.arrayOf(PropTypes.number),
          ])
        ),
        labels: PropTypes.arrayOf(PropTypes.string),
      })
    ),
  }),
  useAPS: PropTypes.bool,
  aps: PropTypes.shape({
    pubID: PropTypes.string,
    bidTimeout: PropTypes.number,
    deals: PropTypes.bool,
    simplerGPT: PropTypes.bool,
  }),
  sizeMappings: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        viewPortSize: PropTypes.arrayOf(PropTypes.number).isRequired,
        sizes: PropTypes.arrayOf(
          PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.arrayOf(PropTypes.number),
          ])
        ).isRequired,
      })
    )
  ),
  slots: PropTypes.arrayOf(AdvertisingSlotConfigPropType),
  outOfPageSlots: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ),
  interstitialSlot: PropTypes.shape({
    path: PropTypes.string.isRequired,
    targeting: PropTypes.object,
  }),
  customEvents: PropTypes.objectOf(
    PropTypes.shape({
      eventMessagePrefix: PropTypes.string.isRequired,
      divIdPrefix: PropTypes.string,
    })
  ),
  enableLazyLoad: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      marginPercent: PropTypes.number,
      mobileScaling: PropTypes.number,
    }),
  ]),
});
